<template>
  <div>
    <button
            type="button"
            @click="generateVideo()"
            class="btn btn-secondary btn-block text-white"
            :disabled="moreThenOneFormatSelected || selectedPosters.length < 3"
            :title="titleText">
      <i v-if="generatingVideo" class="fas fa-circle-notch fa-spin"></i>
      <i v-else class="fas fa-film"></i>
      {{ generateVideoText }}
    </button>

    <canvas id="video-canvas" class="video-canvas"></canvas>
  </div>
</template>

<script>
  import Whammy from '../whammy';
  import bootbox from "../bootbox.min";

  export default {
    name: "generate-posters-video",

    props: {
      videoUrl: String,
      selectedPosters: Array,
      moreThenOneFormatSelected: Boolean,
      moreThenOneFormatSelectedTitle: String,
    },

    mounted() {
      // this.canvas = document.getElementById("video-canvas");
      // this.context = this.canvas.getContext("2d");
      //
      // this.video = new window.Whammy.Video(15);
    },

    computed: {
      titleText() {
        if(this.moreThenOneFormatSelected)
          return this.moreThenOneFormatSelectedTitle;

        if (this.selectedPosters.length < 3)
          return 'Selecione ao menos 3 ofertas para geração de vídeo';
      },

      generateVideoText() {
        return (this.generatingVideo) ? 'Gerando' : 'Gerar Vídeo';
      },
    },

    data() {
      return {
        generatingVideo: false,
        ctx: 0,
        canvas: undefined,
        context: undefined,
        postersPaths: [],

        video: undefined,
      }
    },

    methods: {
      generateVideo() {
        return bootbox.prompt({
          title: "Insira a duração de cada oferta em segundos",
          value: 1,
          buttons: {
            confirm: {
              label: 'Gerar',
              className: 'btn btn-outline-secondary',
            },
            cancel: {
              label: 'Cancelar',
              className: 'btn btn-outline-secondary',
            },
          },
          inputType: 'number',
          callback: (duration) => {
            if (duration && !isNaN(duration)) {
              return this.downloadVideoFromBackEnd(duration);
            }
          }
        });
      },

      downloadVideoFromBackEnd(duration) {
        const vm = this;
        vm.generatingVideo = true;

        axios({
          method: 'post',
          url: this.videoUrl,
          data: {posters: this.selectedPosters, duration: duration},
          responseType: 'blob',
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'ofertas.mp4');
          document.body.appendChild(link);
          link.click();
        }).catch((error) => {
          const defaultMessage = 'Houve um problema ao gerar o vídeo das ofertas.';
          this.$root.throwFlashMessage('danger', _.get(error, 'response.data.message', defaultMessage));
        }).finally(() => vm.generatingVideo = false);
      },

      finalizeVideo() {
        if (this.ctx == this.postersPaths.length) {
          this.generatingVideo = false;
          const output = this.video.compile();
          const url = webkitURL.createObjectURL(output);
          const link = document.createElement('a');

          link.href = url;
          link.setAttribute('download', `video`);
          document.body.appendChild(link);
          link.click();
        }

      },

      process(file) {
        let img = new Image();

        //load image and drop into canvas
        img.onload = () => {

          //a custom fade in and out slideshow
          this.context.globalAlpha = 0.2;
          this.context.drawImage(img, 0, 0, this.canvas.width, this.canvas.height);
          this.video.add(this.context);
          this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height);
          this.context.globalAlpha = 0.4;
          this.context.drawImage(img, 0, 0, this.canvas.width, this.canvas.height);
          this.video.add(this.context);
          this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height);
          this.context.globalAlpha = 0.6;
          this.context.drawImage(img, 0, 0, this.canvas.width, this.canvas.height);
          this.video.add(this.context);
          this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height);
          this.context.globalAlpha = 0.8;
          this.context.drawImage(img, 0, 0, this.canvas.width, this.canvas.height);
          this.video.add(this.context);
          this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height);
          this.context.globalAlpha = 1;
          this.context.drawImage(img, 0, 0, this.canvas.width, this.canvas.height);

          //this should be a loop based on some user input
          this.video.add(this.context);
          this.video.add(this.context);
          this.video.add(this.context);
          this.video.add(this.context);
          this.video.add(this.context);
          this.video.add(this.context);
          this.video.add(this.context);

          this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height);
          this.context.globalAlpha = 0.8;
          this.context.drawImage(img, 0, 0, this.canvas.width, this.canvas.height);
          this.video.add(this.context);
          this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height);
          this.context.globalAlpha = 0.6;
          this.context.drawImage(img, 0, 0, this.canvas.width, this.canvas.height);
          this.video.add(this.context);
          this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height);
          this.context.globalAlpha = 0.4;
          this.context.drawImage(img, 0, 0, this.canvas.width, this.canvas.height);
          this.video.add(this.context);

          this.ctx++;
          this.finalizeVideo();

        };
        img.src = file;
      },

    }
  }
</script>

<style scoped>
  .video-canvas {
    position: fixed;
    right: -10000px;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/GeneratePostersVideo.vue